import CTLBooleanCell from "application/components/CTLBooleanCell";
import { nmsMenus } from "globals/configuration/nms";

const Attributes = {
  formSize: "md",
  settingsMode: false,
  columns: 4,
  enablePriPublish: false,
  modes: nmsMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  messages: {
    success: "CASQ port configuration updated successfully",
    error: "Unable to update CASQ port configuration",
  },
};

const operationURLS = {
  list: "/casq/ports",
  update: "/casq/ports/update",
};

const portColumn = (port) => ({
  Header: `Port ${port}`,
  accessor: `port${port}`,
  displayInList: true,
  allowInForm: true,
  allowFilter: false,
  dataType: "boolean",
  controlType: "boolean",
  width: 3,
  Cell: ({ value }) => <CTLBooleanCell value={value} />,
});

const getColumns = () => {
  return [1, 2, 3, 4, 5, 6, 7, 8].map((port) => portColumn(port));
};

export { getColumns, Attributes, operationURLS };
